import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState} from '@app/redux';
import {map} from 'rxjs/operators';
import {navigateTo} from '@app/redux/app.actions';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(public router: Router, private store: Store<AppState>) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean{
    let token = localStorage.getItem('token');

    if(token){
      return true;
    }

    return this.store.select(appState => appState.auth).pipe(map(isAuth => {
      if (!isAuth || !isAuth.isAuthenticated) {
        this.store.dispatch(navigateTo({path: 'login'}));
      }
      return true;
    }));
  }
}
